/* displayAlertOnSp(targetClassName)
 *
 * @params {string} targetClassName activeを付与する対象のクラス名
*/

import Parser from 'ua-parser-js';

const addActiveToElement = ($targetClassName) => {
  const $targetEl = document.querySelector(`.${$targetClassName}`);
  if ($targetEl !== null) {
    $targetEl.classList.add('active');
  }
};

const isDeviceSp = () => {
  return Parser().device.type === 'mobile';
};

const displayAlertOnSp = (targetClassName) => {
  if (isDeviceSp()) {
    addActiveToElement(targetClassName);
  }
};

export default displayAlertOnSp;
